// messaging.service.ts
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {
  private messageSubject = new BehaviorSubject<any>(null);
  currentMessage$ = this.messageSubject.asObservable();

  constructor(private afMessaging: AngularFireMessaging,public toastr : ToastrService) {
    // this.recieveMessaging();
    this.listenMessaging();
  }

  requestPermission() {
    this.afMessaging.requestToken
      .subscribe(
        (token) => {
          console.log('FCM Token:', token),
        localStorage.setItem('notificationToken',token)
        },
        (error) => console.error('Permission denied', error)
      );
  }

  // recieveMessaging() {
  //   this.afMessaging.messages
  //     .subscribe((message:any) => {
  //       this.toastr.info(message.notification.title);
  //       console.log('message',message);
     
  //       sessionStorage.setItem('receiveMsg',JSON.stringify(message))
  //     });
  // }
   listenMessaging() {
    this.afMessaging.messages.subscribe((message: any) => {

      if (!message) return;

      this.toastr.info(message.notification?.title);
      console.log('message', message);

      sessionStorage.setItem('receiveMsg', JSON.stringify(message));

      // ⭐ Emit event to components
      this.messageSubject.next(message);

    });
  }
}
